import HTTPClient from './http-client';

const headers = {headers: {'Content-Type': 'application/json'}};

const loadDesmatamentosAnual = async (payload) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.post(`/desmatamentos_anual`, payload, headers);
}

const loadDesmatamentosMensal = async (payload) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.post(`/desmatamentos_mensal`, payload, headers);
}

const loadDesmatamentosSemestral = async (payload) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.post(`/desmatamentos_semestral`, payload, headers);
}

const loadDesmatamentosTrimestral = async (payload) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.post(`/desmatamentos_trimestral`, payload, headers);
}

export {
  loadDesmatamentosAnual,
  loadDesmatamentosMensal,
  loadDesmatamentosSemestral,
  loadDesmatamentosTrimestral,
}
